<div class="contact-info-container">
  <form [formGroup]="formGroup" class="form-section">
    <p class="heading-one">Contact Information</p>
    <div>
      <div>
        <!-- Company Name -->
        <lib-text-field-alls
          #nameCompany
          [isSubmitted]="isSubmitted"
          [errorMessage]="companyName + isRequired"
          [fullWidth]="true"
          [fieldLabel]="companyName"
          [placeholder]="'ABCD'"
          [fieldLength]="100"
          [fieldName]="'companyName'"
          [alignmentRight]="false"
          [required]="true"
          [formControlData]="formGroup"
          (inputFieldData)="fieldValue($event, 'companyName')"
        >
        </lib-text-field-alls>
      </div>
      <div class="gap-top">
        <!-- contact Name -->
        <lib-text-field-alls
          #nameContact
          [isSubmitted]="isSubmitted"
          [errorMessage]="contactName + isRequired"
          [fullWidth]="true"
          [fieldLabel]="contactName"
          [placeholder]="'ABCD'"
          [fieldLength]="80"
          [fieldName]="'contactName'"
          [alignmentRight]="false"
          [required]="true"
          [formControlData]="formGroup"
          (inputFieldData)="fieldValue($event, 'contactName')"
        >
        </lib-text-field-alls>
      </div>
      <div class="gap-top">
        <!-- phone number -->
        <lib-phone-validator
          #phone
          [fieldLabel]="phoneNumber"
          [placeholder]="'(000) 000 0000'"
          [isSubmitted]="isSubmitted"
          (inputFieldData)="fieldValue($event, 'phoneNumber')"
        >
        </lib-phone-validator>
      </div>
      <div class="gap-top">
        <!-- email -->
        <lib-email-validator
          #email
          [isSubmitted]="isSubmitted"
          [fieldLabel]="emailAddress"
          (inputFieldData)="fieldValue($event, 'email')"
        ></lib-email-validator>
      </div>
    </div>
    <div>
      <!-- action buttons -->
      <up-button button-style="text" (click)="resetAction.emit()">Reset</up-button>
      <up-button button-style="contained" (click)="onClickNext()">Next</up-button>
    </div>
  </form>

  <div class="image-section">
     <!-- image-->
    <img
      class="partner-icon"
      [src]="imageTruck"
      [alt]="'Loup Network Partner'"
      width="18"
      height="18"
      loading="lazy"
      decoding="async"
    />
  </div>
</div>
